import React, { useEffect, useState } from "react";
import {
  loadCustomerForm,
  loadApiEndPoint,
  saveApiEndpoint,
} from "../../api/adminApi";

const CustomerApiEndPoint = () => {
  const [isLoading, setLoading] = useState(false);
  const [dyForm, setDyForm] = useState([]);
  const [dyFormJson, setDyFormJson] = useState([]);
  const [dyFormName, setDyFormName] = useState("");
  const [endPointFormVisibility, setEndPointFormVisibility] = useState({});
  const [endPointFormData, setEndPointFormData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await loadCustomerForm();
        if (response?.data?.json && Array.isArray(response.data.json)) {
          setDyForm(response.data);
          setDyFormJson(response.data.json);
        } else {
          alert("Invalid response format. Please try again.");
        }
      } catch (error) {
        alert("Failed to fetch Customer Form. Please try again later.");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const saveEndPointFormData = async (index) => {
    const form = document.getElementById(`endpoint-form-${index}`);
    if (form) {
      const formData = new FormData(form);
      const data = Object.fromEntries(formData.entries());

      if (!data.endpoint) {
        alert("Endpoint is required.");
        return;
      }
      if (!data.returnType) {
        alert("Return type is required.");
        return;
      }
      if (!data.methodType) {
        alert("Method type is required.");
        return;
      }

      console.log(data);
      
      try {
        const response = await saveApiEndpoint(data);
        console.log(response);
        if (response.status === 200) {
          alert("API Endpoint saved successfully!");
          setEndPointFormVisibility((prev) => ({ ...prev, [index]: false }));
        } else {
          alert("Failed to save API Endpoint. Please try again.");
        }
      } catch (error) {
        console.error("Error saving form data:", error);
        alert("An error occurred while saving. Please try again.");
      }
    }
  };

  const handleCheckboxChange = async (checked, index, label) => {
    setEndPointFormVisibility((prev) => ({
      ...prev,
      [index]: checked,
    }));

    if (checked) {
      try {
        const response = await loadApiEndPoint(dyForm.id, label);
        if (response.status == 200 && response.data) {
          const { endpoint, returnType, methodType, rowCount } = response.data;
          setEndPointFormData((prev) => ({
            ...prev,
            [index]: {
              endpoint: endpoint || "",
              returnType: returnType || "TEXT",
              methodType: methodType || "GET",
              rowCount: rowCount || 0,
            },
          }));
        }
      } catch (error) {
        console.error("Error during API call:", error);
        alert("Failed to load API settings.");
      }
    }
  };
  const renderField = (field, index) => {
    if (field.type === "text") {
      return (
        <div key={index} className="flex items-center justify-center">
          <div className="bg-white mt-4 p-4 bg-blue-50 rounded-lg shadow">
            <div className="flex items-center mb-4 space-x-4">
              <div className="flex-1">
                <input
                  type="text"
                  value={field.label}
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  disabled
                />
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id={`api-endpoint-setting-${index}`}
                  className="mr-2"
                  onChange={(e) =>
                    handleCheckboxChange(e.target.checked, index, field.label)
                  }
                />
                <label
                  htmlFor={`api-endpoint-setting-${index}`}
                  className="text-sm font-medium text-gray-700"
                >
                  Set API Endpoint settings
                </label>
              </div>
            </div>

            {endPointFormVisibility[index] && (
              <div className="mt-4 p-4 border rounded-md bg-gray-50">
                <form id={`endpoint-form-${index}`}>
                  <input type="hidden" name="dyFormId" value={dyForm.id} />
                  <input type="hidden" name="inputLabel" value={field.label} />

                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700">
                      EndPoint Address
                    </label>
                    <input
                      type="text"
                      name="endpoint"
                      className="w-full p-2 border border-gray-300 rounded-md"
                      value={endPointFormData[index]?.endpoint || ""}
                      onChange={(e) => setEndPointFormData((prev) => ({
                        ...prev,
                        [index]: {
                          ...prev[index],
                          endpoint: e.target.value,
                        }
                      }))}
                      required
                    />
                  </div>

                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700">
                      Return Type:
                    </label>
                    <select
                      name="returnType"
                      className="w-full p-2 border border-gray-300 rounded-md"
                      value={endPointFormData[index]?.returnType || "TEXT"}
                      onChange={(e) => setEndPointFormData((prev) => ({
                        ...prev,
                        [index]: {
                          ...prev[index],
                          returnType: e.target.value,
                        }
                      }))}
                      required
                    >
                      <option value="TEXT">Text</option>
                      <option value="JSON">JSON</option>
                    </select>
                  </div>

                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700">
                      API Method Type:
                    </label>
                    <select
                      name="methodType"
                      className="w-full p-2 border border-gray-300 rounded-md"
                      value={endPointFormData[index]?.methodType || "GET"}
                      onChange={(e) => setEndPointFormData((prev) => ({
                        ...prev,
                        [index]: {
                          ...prev[index],
                          methodType: e.target.value,
                        }
                      }))}
                      required
                    >
                      <option value="GET">GET</option>
                      <option value="POST">POST</option>
                    </select>
                  </div>

                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700">Row Count</label>
                    <input
                      type="number"
                      name="rowCount"
                      min="1"
                      max="10"
                      className="w-full p-2 border rounded-md"
                      value={endPointFormData[index]?.rowCount || ""}
                      onChange={(e) =>
                        setEndPointFormData((prev) => ({
                          ...prev,
                          [index]: {
                            ...prev[index],
                            rowCount: e.target.value,
                          },
                        }))
                      }
                    />
                  </div>

                  <button type="button" className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600" onClick={() => saveEndPointFormData(index)}>
                    Submit
                  </button>
                </form>
              </div>
            )}
          </div>
        </div>
      );
    }
    return null;
  };

  return (<>
    <div>
      {isLoading ? (
        <p className="text-center text-blue-700">Loading ticketHeads...</p>
      ) : (
        dyForm && dyFormJson.map(renderField)
      )}
    </div>
  </>);
}
export default CustomerApiEndPoint;